<script setup lang="ts">
import { CreateButton } from '@/components/Buttons'
import StackLayout from '../Layouts/StackLayout.vue'
import HrefWrapper from '../Wrappers/HrefWrapper.vue'

type Props = {
    label: string
    href: string
    loading?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'click'): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout class="fit-content place-self-end">
        <HrefWrapper hasPermission :href="href">
            <CreateButton :loading="loading" :label="label" />
        </HrefWrapper>
    </StackLayout>
</template>
